// **Redux Imports
import { createSlice } from '@reduxjs/toolkit'

export const candidateSlice = createSlice({
  name: 'candidate',
  initialState: {
    contestDetails: {},
    contestStageDetails: {},
    stageChallegesDetails: {}
  },
  reducers: {
    updateMCQChallengeQuestionFlag(state, action) {
      const { questionIndex, flag } = action.payload

      state.contestStageDetails.challenges[0].questions[questionIndex].flag =
        flag
    },
    updateMCQChallengeQuestionSelectedOption(state, action) {
      const { questionIndex, selectedOptions } = action.payload

      state.contestStageDetails.challenges[0].questions[
        questionIndex
      ].optionsIds = selectedOptions.map((option) => option)
    },
    setContestDetails(state, action) {
      state.contestDetails = action.payload
    },
    setContestStageDetails(state, action) {
      state.contestStageDetails = action.payload
    },
    updateMcqStageSkillsPreferenceFlag(state, action) {
      state.contestStageDetails.isPreferredTopicSelected = action.payload
    },
    updateStageChallengeDetails(state, action) {
      const { challengeId, key, value } = action.payload
      if (state.stageChallegesDetails?.[challengeId]) {
        if (state?.stageChallegesDetails?.[challengeId]?.[key]) {
          state.stageChallegesDetails[challengeId][key] = value
        }
      }
    },
    setStageChallengeDetails(state, action) {
      state.stageChallegesDetails = action.payload
    },
    resetStageDetails(state, action) {
      state.contestStageDetails = {}
      state.stageChallegesDetails = {}
    }
  },
  extraReducers: (builder) => {}
})

export const {
  resetStageDetails,
  setContestDetails,
  setContestStageDetails,
  setStageChallengeDetails,
  updateStageChallengeDetails,
  updateMCQChallengeQuestionFlag,
  updateMcqStageSkillsPreferenceFlag,
  updateMCQChallengeQuestionSelectedOption
} = candidateSlice.actions

export default candidateSlice.reducer
